module.exports = __webpack_public_path__ + "img/mermaid-underwater.7a03458f.jpg";